/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SpeakersPageQuery = {
    readonly home: {
        readonly items: ReadonlyArray<{
            readonly stopLookingForSpeakers: boolean;
        } | null> | null;
    } | null;
    readonly speakers: {
        readonly items: ReadonlyArray<{
            readonly _children: {
                readonly items: ReadonlyArray<{
                    readonly _id?: string;
                    readonly _url?: string | null;
                    readonly speakerName?: string;
                    readonly speakerPreviewDescription?: string | null;
                    readonly speakerImage?: string;
                    readonly location?: {
                        readonly city?: string;
                        readonly countryName?: string;
                        readonly country?: {
                            readonly _url?: string | null;
                        };
                    };
                    readonly facebookLink?: string | null;
                    readonly twitterLink?: string | null;
                    readonly linkedinLink?: string | null;
                } | null> | null;
            } | null;
        } | null> | null;
    } | null;
    readonly " $refType": "SpeakersPageQuery";
};
export type SpeakersPageQuery$data = SpeakersPageQuery;
export type SpeakersPageQuery$key = {
    readonly " $data"?: SpeakersPageQuery$data;
    readonly " $fragmentRefs": FragmentRefs<"SpeakersPageQuery">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "_url",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SpeakersPageQuery",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "HomePublishedContentConnection",
      "kind": "LinkedField",
      "name": "home",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "HomePublishedContent",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "stopLookingForSpeakers",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SpeakersPublishedContentConnection",
      "kind": "LinkedField",
      "name": "speakers",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SpeakersPublishedContent",
          "kind": "LinkedField",
          "name": "items",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "PublishedContentConnection",
              "kind": "LinkedField",
              "name": "_children",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "items",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "_id",
                          "storageKey": null
                        },
                        (v0/*: any*/),
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "speakerName",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "speakerPreviewDescription",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "speakerImage",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": null,
                          "kind": "LinkedField",
                          "name": "location",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "InlineFragment",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "city",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "countryName",
                                  "storageKey": null
                                },
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": null,
                                  "kind": "LinkedField",
                                  "name": "country",
                                  "plural": false,
                                  "selections": [
                                    {
                                      "kind": "InlineFragment",
                                      "selections": [
                                        (v0/*: any*/)
                                      ],
                                      "type": "FilePublishedMedia",
                                      "abstractKey": null
                                    }
                                  ],
                                  "storageKey": null
                                }
                              ],
                              "type": "LocationPublishedContent",
                              "abstractKey": null
                            }
                          ],
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "facebookLink",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "twitterLink",
                          "storageKey": null
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "linkedinLink",
                          "storageKey": null
                        }
                      ],
                      "type": "SpeakerPublishedContent",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PublishedContentByTypeQuery",
  "abstractKey": null
};
})();
(node as any).hash = '989ff3acfdb1d182d57cea8eac7eda65';
export default node;
